import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { StyledArrowDown, StyledArrowUp } from "./CollapseToggle.styles";
export var CollapseToggle = function(param) {
    var isCollapsed = param.isCollapsed, rules = param.rules;
    var ref = rules || {}, _iconSize = ref.iconSize, iconSize = _iconSize === void 0 ? 60 : _iconSize;
    var ArrowComponent = isCollapsed ? StyledArrowDown : StyledArrowUp;
    return /*#__PURE__*/ _jsx(ArrowComponent, {
        iconSize: iconSize
    });
};
